import discardReplyOption from './actions/discardReplyOption';
import saveReplyOption from './actions/saveReplyOption';
import ReplyFull from './components/ReplyFull';
import isReplyOptionDirty from './utils/isReplyOptionDirty';
import * as React from 'react';
var ReplyOption = {
    key: 'reply',
    titleStringKey: 'optionTitle_reply',
    searchTermsStringKey: 'optionTitle_reply',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReplyFull, null); },
        isDirty: isReplyOptionDirty,
        onSave: saveReplyOption,
        onDiscard: discardReplyOption,
    },
};
export default ReplyOption;
//# sourceMappingURL=ReplyOption.js.map